var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.584961C7.39303 0.584961 5.82214 1.06148 4.486 1.95427C3.14985 2.84706 2.10844 4.11601 1.49348 5.60066C0.87852 7.08531 0.717618 8.71897 1.03112 10.2951C1.34463 11.8712 2.11846 13.3189 3.25476 14.4552C4.39106 15.5915 5.8388 16.3653 7.4149 16.6788C8.99099 16.9923 10.6247 16.8314 12.1093 16.2165C13.594 15.6015 14.8629 14.5601 15.7557 13.224C16.6485 11.8878 17.125 10.3169 17.125 8.70996C17.1209 6.55635 16.2635 4.49212 14.7407 2.96928C13.2178 1.44644 11.1536 0.589091 9 0.584961ZM13.375 9.33496H9C8.83424 9.33496 8.67527 9.26911 8.55806 9.1519C8.44085 9.03469 8.375 8.87572 8.375 8.70996V4.33496C8.375 4.1692 8.44085 4.01023 8.55806 3.89302C8.67527 3.77581 8.83424 3.70996 9 3.70996C9.16576 3.70996 9.32474 3.77581 9.44195 3.89302C9.55916 4.01023 9.625 4.1692 9.625 4.33496V8.08496H13.375C13.5408 8.08496 13.6997 8.15081 13.8169 8.26802C13.9342 8.38523 14 8.5442 14 8.70996C14 8.87572 13.9342 9.03469 13.8169 9.1519C13.6997 9.26911 13.5408 9.33496 13.375 9.33496Z",
    fill: "#D7C0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLater);
export default __webpack_public_path__ + "static/media/later.62dd94af739b806c7f89fb691ffbc44b.svg";
export { ForwardRef as ReactComponent };